module.exports = __webpack_public_path__ + "static/img/shiyong.7ed2a4e3.png";